import { render, staticRenderFns } from "./ClockWidget.vue?vue&type=template&id=4cdf557e&scoped=true"
import script from "./ClockWidget.vue?vue&type=script&lang=js"
export * from "./ClockWidget.vue?vue&type=script&lang=js"
import style0 from "./ClockWidget.vue?vue&type=style&index=0&id=4cdf557e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf557e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdf557e')) {
      api.createRecord('4cdf557e', component.options)
    } else {
      api.reload('4cdf557e', component.options)
    }
    module.hot.accept("./ClockWidget.vue?vue&type=template&id=4cdf557e&scoped=true", function () {
      api.rerender('4cdf557e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/ClockWidget.vue"
export default component.exports